import React from 'react';
import { partial } from 'lodash';
import { SwitchItem } from '../../Forms/SwitchItem';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { FORM_MARGIN, SUPPORT_LINKS } from './constants';

interface IProps {
  emptyCartProductSuggestion: IShopSalesAutomation['emptyCartProductSuggestion'];
  updateFormValue: (path: string, value: unknown) => void;
}

export const EmptyCartProductSuggestionSection = React.memo(
  ({ emptyCartProductSuggestion, updateFormValue }: IProps) => (
    <SwitchItem
      value={emptyCartProductSuggestion?.enabled}
      changeCallback={partial(updateFormValue, 'emptyCartProductSuggestion.enabled')}
      label={getTranslationKey('collectionShop.emptyCartLProductLabel')}
      direction="row-reverse"
      margin={FORM_MARGIN}
      id="emptyCartProductSuggestion-switch"
      withTooltip
      tooltipText={getTranslationKey('learnMoreLink', {
        link: SUPPORT_LINKS.emptyCartSuggestion,
        text_link: SUPPORT_LINKS.emptyCartSuggestion
      })}
      isIconTooltip
    />
  )
);
